import type { DealXgSocketProcessor } from '../types';
import { syncDealRefId } from './syncDealRefId';

/**
 * TODO: HL: Needs to refactor this.
 */
/**
 * Registry of DealXG socket-event processors.
 */
const processors: DealXgSocketProcessor[] = [syncDealRefId];

export const processDealXgSocketEvent: DealXgSocketProcessor = (store, action) => {
    processors.forEach((process) => process(store, action));
};
